import { CategoryData } from "../../categories/interfaces/dto";
import { CategoryListResponse } from "../../categories/interfaces/http-responses";
import { fetchSpecificCategories } from "../../categories/services/category-list-service";

const { findHtmlEl, emptyElement } = pm.utils.dom;

export default function renderCategories(
	popup: HTMLElement,
	categoryIds: Array<number>,
) {
	const listWrapper = findHtmlEl(popup, ".category-list");
	if (!listWrapper) return;

	if (categoryIds.length === 0) {
		listWrapper.style.display = "none";
		return;
	}

	buildCategoryPlaceholders(categoryIds, listWrapper);

	const nonce: string = popup.dataset.fetchCategoriesNonce
		? popup.dataset.fetchCategoriesNonce
		: "";

	// No need to handle the "catch" here because it's handled in the service.
	fetchSpecificCategories(categoryIds, nonce).then(
		(response: CategoryListResponse) => {
			if (!response.success) return;
			const categoryDataList: Array<CategoryData> = response.data;

			// Remove items inside listWrapper except first one.
			while (listWrapper.children.length > 1) {
				listWrapper.removeChild(listWrapper.lastChild!);
			}

			buildCategoryItems(categoryDataList, listWrapper);
		},
	);
}

function buildCategoryPlaceholders(
	categoryIds: number[],
	listWrapper: HTMLElement,
) {
	emptyElement(listWrapper);

	for (let i = 0; i < categoryIds.length; i++) {
		const a = document.createElement("a");
		a.classList.add("is-waiting");
		a.innerHTML = "&nbsp;";
		a.href = "";
		a.style.minWidth = "85px";

		const li = document.createElement("li");
		li.style.marginRight = "7px";
		li.appendChild(a);
		listWrapper.appendChild(li);
	}
}

function buildCategoryItems(
	categoryDataList: CategoryData[],
	listWrapper: HTMLElement,
) {
	emptyElement(listWrapper);

	for (let i = 0; i < categoryDataList.length; i++) {
		const a = document.createElement("a");
		a.href = categoryDataList[i].url;
		a.innerHTML = categoryDataList[i].name;

		const li = document.createElement("li");
		li.style.marginRight = "7px";
		li.appendChild(a);
		listWrapper.appendChild(li);
	}
}
